import { render } from "./CandleFormStep3.vue?vue&type=template&id=b601287e&scoped=true&lang=html"
import script from "./CandleFormStep3.vue?vue&type=script&lang=js"
export * from "./CandleFormStep3.vue?vue&type=script&lang=js"

import "./CandleFormStep3.vue?vue&type=style&index=0&id=b601287e&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b601287e"]])

export default __exports__